export default __webpack_public_path__ + "static/media/login-bg.737399e5.png";